import { X } from "lucide-react";

import { Button } from "components/common/buttons/Button";
import { useProjectNoticeDismissal } from "hooks/useProjectNoticeDismissal";
import { cn } from "utils/cn";
import { SCHEDULE_BUDGET_TAGS_EDUCATION } from "utils/scheduleBudgetTaggingCopy";

export const ScheduleBudgetTagsEducationBanner = ({
  projectId,
  className,
}: {
  projectId: string;
  className?: string;
}) => {
  const { dismissed, dismiss } = useProjectNoticeDismissal(projectId, "schedule-budget-tags");

  if (dismissed) return null;

  return (
    <div
      className={cn(
        "mb-4 flex items-center justify-between gap-3 rounded-lg border border-border bg-muted/50 px-4 py-3 text-regular-3 text-muted-foreground",
        className
      )}
      role="note"
    >
      <span>{SCHEDULE_BUDGET_TAGS_EDUCATION}</span>
      <Button
        type="button"
        color="gray"
        size="icon"
        onClick={dismiss}
        className="h-7 w-7 shrink-0"
        aria-label="Dismiss script tags guidance"
      >
        <X aria-hidden />
      </Button>
    </div>
  );
};
